import React, { useEffect, useMemo, useState } from "react";
import styles from "./ServiceDetails.module.css";
import SEO from "../../components/SEO/SEO";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import servicesService from "../../services/services";
import { useParams } from "react-router-dom";
import useDeviceWidth from "../../components/device-width/UseDeviceWidth";
import { useSelector } from "react-redux";
import AdjustFontSize from "../../components/adjust-font-size/AdjustFontSize";
import RelatedItems from "./related-items/RelatedItems";
import ShareButtons from "../../components/share-buttons/ShareButtons";
import BranchesList from "../service-detail/branches-slider/BranchesList";

const ServiceDetails = () => {


  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const width = useDeviceWidth();
  const { homeApis } = useSelector((state) => state.widget);

  // Memoize services and branches to prevent unnecessary re-renders
  const services = useMemo(
    () => homeApis?.services || [],
    [homeApis?.services]
  );
  const branches = useMemo(
    () => homeApis?.branches || [],
    [homeApis?.branches]
  );

  // Memoize responsive HTML to avoid recalculating unless necessary
  const responsiveHtml = useMemo(() => {
    if (!service?.content) return "";
    return AdjustFontSize(service.content, width);
  }, [service?.content, width]);

  // Memoize filtered related items
  const relatedItems = useMemo(
    () => services.filter((item) => item.slug !== slug),
    [services, slug]
  );

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (!slug) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const serviceRes = await servicesService.getBySlug(slug);

        if (isMounted) {
          console.log("FETCHED SERVICE:", serviceRes?.data);
          setService(serviceRes?.data || null);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching service:", error);
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [slug]);

  // Early return for better readability
  if (loading) return <LoadingSpinner />;

  // Render nothing if service is not found
  // if (!service) return null;

  return (
    <>
      <SEO seo={service} />
      <div className={styles.container}>
        <div className={styles.description}>
          <div className={styles.divA}>
            <section className={styles.banner}>
              <div className={styles.bannerBack}>
                <img
                  src={
                    width > 568
                      ? "/img/designs/detail-back.png"
                      : "/img/designs/detail-back-mob.png"
                  }
                  alt="bannerBack"
                  className={styles.bannerBack}
                />
              </div>
              <div className={styles.imageSection}>
                <img
                  src={service.image?.url || "/img/default-banner.jpg"}
                  alt={service.image?.imageTag || "Service Banner"}
                />
              </div>
              <div className={styles.titleSection}>
                <div
                  className={styles.imageDiv}
                  data-aos="fade-down"
                  data-aos-delay="200"
                >
                  <img
                    src={service.icon || "/img/default-icon.png"}
                    alt={service.image?.imageTag || "Service Icon"}
                    loading="lazy"
                  />
                </div>
                <p data-aos="fade-right" data-aos-delay="200">
                  {service.title}
                </p>
              </div>
            </section>
            {/* <div className={styles.div1}>
              <img
                src="https://via.placeholder.com/150"
                alt="Service"
                className={styles.div1Image}
              />
              <div className={styles.div1Content}>
                <span className={styles.date}>June 4, 2025</span>
                <h2 className={styles.title}>Comprehensive Health Checkup</h2>
              </div>
            </div> */}
            <div
              className={`${styles.serviceContent} detail-description`}
              dangerouslySetInnerHTML={{ __html: responsiveHtml }}
            />
            <ShareButtons />
          </div>
          <div className={styles.divB}>
            <RelatedItems data={relatedItems} />
            {/* <h3 className={styles.relatedTitle}>Related Services</h3>
        <div className={styles.cardsContainer}>
          {relatedServices.map((service) => (
            <div key={service.id} className={styles.card}>
              <img
                src={service.image}
                alt={service.title}
                className={styles.cardImage}
              />
              <div className={styles.cardContent}>
                <h4 className={styles.cardTitle}>{service.title}</h4>
                <p className={styles.cardDescription}>{service.description}</p>
              </div>
            </div>
          ))}
        </div> */}
          </div>
        </div>
        {branches.length > 0 && (
          <div className={styles.branchSlider}>
            <BranchesList data={branches} />
          </div>
        )}
      </div>
    </>
  );
};

export default ServiceDetails;
